import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast";
import { useToast } from "../../hooks/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(
        ({
          id,
          title,
          description,
          action,
          variant,
          icon,
          showProgress,
          duration,
          ...props
        }) => (
          <Toast
            key={id}
            variant={variant}
            icon={icon}
            showProgress={showProgress}
            duration={duration}
            {...props}
          >
            <div className="grid gap-1 flex-1">
              {/* {title && <ToastTitle>{title}</ToastTitle>} */}
              {description ? (
                <ToastDescription>{description}</ToastDescription>
              ) : title ? (
                <ToastTitle>{title}</ToastTitle>
              ) : null}
            </div>
            {action}
            <ToastClose />
          </Toast>
        ),
      )}
      <ToastViewport />
    </ToastProvider>
  );
}
